export const chip = {
  colorScheme: {
    light: {
      background: '{surface.100}',
      color: '{neutral.900}',
      borderColor: '{surface.600}',
    },
    dark: {
      background: '#333643',
      color: 'white',
      border: {
        color: 'none',
      },
    },
  },
  css: ({ dt }: { dt: (key: string) => string }) => `
      .p-chip{
      padding: 0.6rem 1rem;
      gap: 0.75rem
      }
      .p-chip:has(.p-chip-remove-icon){
      padding-inline-end: 1rem;
      }
    `,
};
